import React from 'react'
import Grid from '@material-ui/core/Grid'
import { Field } from 'react-final-form'
import { CrudForm, useEntityManager } from 'elentari'
import transportadoraConfiavelRepository from './transportadoraConfiavelRepository'
import { parseTelefone } from '../../utils/Parse'
import { CustomTextField } from '../../components/CustomDisabledFields'

const validate = data => ({
  nome: data.nome ? undefined : 'Obrigatório'
})

const TransportadoraConfiavelForm = props => {
  const entityManager = useEntityManager({
    repository: transportadoraConfiavelRepository
  })

  const handleSubmit = data => {
    return entityManager.onSubmit(data)
  }

  return (
    <CrudForm
      {...props}
      {...entityManager}
      onSubmit={handleSubmit}
      validate={validate}
      withPaper
    >
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Field
            fullWidth
            name="nome"
            component={CustomTextField}
            label="Nome"
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Field
            fullWidth
            name="telefone"
            component={CustomTextField}
            label="Telefone"
            parse={parseTelefone}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Field
            fullWidth
            name="referencia"
            component={CustomTextField}
            label="Referência"
          />
        </Grid>
        <Grid item xs={12}>
          <Field
            fullWidth
            component={CustomTextField}
            label="Observação"
            name="observacao"
          />
        </Grid>
      </Grid>
    </CrudForm>
  )
}

export default TransportadoraConfiavelForm
